import React from "react";
import {StyledEditTemplate, TemplateHeader} from "./EditTemplate.style";
import TemplateSidebar from "./TemplateSidebar";
import previewPage from "../../../../assets/WebsiteBuilder/previewPage.jpg";
import modalBg from "../../../../assets/WebsiteBuilder/modalBg.png";
import Button from "components/molecules/Button";
import {IoIosArrowBack} from "react-icons/io";
import {useNavigate} from "react-router-dom";
import ModalContainer from "components/molecules/ModalContainer";
import TemplateCreatedModal from "./TemplateCreatedModal";

const EditTemplate = () => {
    const navigate = useNavigate();
    return (
        <>
            <TemplateHeader>
                <div className="title-wrap">
                    <Button width="90px" variant="completed" onClick={() => navigate(-1)}>
                        <IoIosArrowBack color="var(--text-color)" />
                        Back
                    </Button>
                    <div>
                        <h2 className="header-title">Edit Website</h2>
                        <span className="template-name">Modern</span>
                    </div>
                </div>
                <div className="btn-wrap">
                    <ModalContainer
                        bg={`url(${modalBg})`}
                        width="983"
                        content={({onClose}) => <TemplateCreatedModal />}
                        btnComponent={({onClick}) => (
                            <Button width="110px" gray onClick={onClick}>
                                Save
                            </Button>
                        )}
                    />
                    <Button width="110px">Preview</Button>
                </div>
            </TemplateHeader>

            <StyledEditTemplate>
                <TemplateSidebar />
                <div className="preview-section">
                    <img src={previewPage} alt="previewPage" className="preview-img" />
                </div>
            </StyledEditTemplate>
        </>
    );
};

export default EditTemplate;
